export default function Go_String() {
  return (
    <div>
      <h1>Go_String </h1>
      <p>String</p>
    </div>
  );
}
